import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject, forwardRef, OnInit, Input, Optional } from '@angular/core';
import { BaseWidget, NgAisInstantSearch, NgAisIndex } from 'angular-instantsearch';
import { connectAutocomplete } from 'instantsearch.js/es/connectors';
import { MEDICAL_STATIC_OPTIONS } from '../../objects/algoliaStaticOptions';

@Component({
  selector: 'app-algolia-medical',
  templateUrl: './algolia-medical.component.html',
  styleUrls: ['./algolia-medical.component.scss']
})
export class AlgoliaMedicalComponent extends BaseWidget implements OnInit {

  declare state: {
    query: string;
    refine: Function;
    indices: object[];
  };
  arrowKeysCode = [37, 38, 39, 40];
  medicalStaticOptions = MEDICAL_STATIC_OPTIONS;
  @Input() placeholder: string;
  @Input() public control: FormControl;
  @Input() public group: FormGroup; /**Form group of the input */
  @Input() type: string;
  @Input() info;
  @Input() label: string;

  constructor(
    @Inject(forwardRef(() => NgAisIndex))
    @Optional()
    public parentIndex: NgAisIndex,
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchInstance: NgAisInstantSearch
  ) {
    super('AutocompleteComponent');
  }

  public ngOnInit() {
    this.createWidget(connectAutocomplete, {});
    super.ngOnInit();
  }

  public handleChange($event: KeyboardEvent) {
    if (!this.arrowKeysCode.includes($event.which)) { // To allow arrow key navigation
      const searchText = ($event.target as HTMLInputElement).value;
      this.state.refine(searchText);
      if (typeof this.control.value !== 'object') {
        this.control.setErrors({ 'notFromList': true });
      }
    }
  }

  displayFn(data: any): string {
    return data && data.name ? data.name : '';
  }

  onSelect(option) {
    this.control.setErrors(null);
  }

}
